import { render, staticRenderFns } from "./tab-kpi-target.vue?vue&type=template&id=0c6d3abe&"
import script from "./tab-kpi-target.vue?vue&type=script&lang=js&"
export * from "./tab-kpi-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports